import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { LiveClassDto, LiveClassServiceDto } from '../../shared/types/LiveClassDto';
import { LiveClassHelpers } from '../live-class.helpers';
import { CohortPollingHelpers } from './cohort-polling.helpers';
import { COHORT_CONFIG_TYPE } from './cohort.config';
import { COHORT_CONFIG_TOKEN } from './cohort.config.token';
import { CohortHelpers } from './cohort.helpers';
import { ModalService } from '../../shared/modal.service';
import { CohortSelectionModalComponent } from './cohort-selection-modal/cohort-selection-modal.component';
import { WindowService } from '../../shared/window.service';

@Injectable()
export class CohortService {
  constructor(
    @Inject(COHORT_CONFIG_TOKEN) public cohortConfig: COHORT_CONFIG_TYPE,
    private http: HttpClient,
    private oeAppService: OeAppService,
    private oeAppPersonService: OeAppPersonService,
    private modalService: ModalService,
    private windowService: WindowService
  ) {}

  public init() {
    if (this.shouldOpenCohortModal()) {
      this.openCohortSelectionModal();
    }
  }

  private shouldOpenCohortModal(): boolean {
    const currentPath = this.windowService.getPathName();
    // Placement is priority: those routes own the screen, the modal must not cover them.
    const isBlockedRoute =
      currentPath.includes('/passwordSetup.html') ||
      currentPath === '/placement-quiz.html' ||
      currentPath === '/level-selection.html';

    return !isBlockedRoute &&
      !this.oeAppPersonService.cohortId &&
      Boolean(this.oeAppPersonService.id) &&
      this.oeAppPersonService.cohortLiveClassEnabled;
  }

  private openCohortSelectionModal() {
    this.modalService.open(CohortSelectionModalComponent, {
      windowClass: 'cohort-selection-modal-window',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }

  public liveClassesPoll$ = CohortPollingHelpers.createHalfHourTimer$().pipe(
    switchMap(() => {
      return CohortPollingHelpers.timedPollUntil$(
        this.getLiveClasses$(),
        this.cohortConfig.msPollInterval,
        (response) =>
          CohortHelpers.getMsToPollStart(response, (cls) => cls.msToClassBegin, this.cohortConfig.msPollStartBuffer),
        (response) => response.some((cls) => Boolean(cls.classroomUrl))
      );
    })
  );

  public getLiveClasses$(): Observable<LiveClassDto[]> {
    const personId = this.oeAppPersonService.id;
    return this.http
      .get<LiveClassServiceDto[]>(`${this.oeAppService.oeLiveClassServiceHost}/v1/liveclasses/cohorts`, {
        params: {
          personId: personId.toString(),
        },
      })
      .pipe(
        map((liveClassSchedules: LiveClassServiceDto[]) => {
          const classes = LiveClassHelpers.convertLiveClassesArrayToDate(liveClassSchedules);
          return classes;
        })
      );
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/cohort/cohort.service.ts